import LoadingState from '@/components/ui/LoadingState';
import styles from './PlanningReportSkeleton.module.css';

type Props = {
  label?: string;
};

export default function PlanningReportSkeleton({ label }: Props) {
  return (
    <div
      className={styles.wrap}
      data-testid="planning-report-skeleton"
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={label}
    >
      <LoadingState variant="skeleton" className={styles.cover} />
      <LoadingState variant="skeleton" className={styles.section} />
      <LoadingState variant="skeleton" className={styles.section} />
      <LoadingState variant="skeleton" className={styles.section} />
      <LoadingState variant="skeleton" className={styles.section} />
      {label ? <p className={styles.status}>{label}</p> : null}
    </div>
  );
}
